import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

function Features() {
  const features = [
    {
      icon: 'fas fa-water',
      title: 'Water Submersion Detection',
      description: 'Automatic dive start/stop with Apple\'s advanced water detection technology (watchOS 10.6+). Manual controls available for all versions.',
      color: '#00bcd4'
    },
    {
      icon: 'fas fa-chart-line',
      title: 'Real-time Decompression',
      description: 'Professional-grade Bühlmann ZH-L16C, VPM-B, and RGBM algorithms with 16 tissue compartments and configurable conservatism.',
      color: '#4CAF50'
    },
    {
      icon: 'fas fa-heartbeat',
      title: 'Comprehensive Sensors',
      description: 'Track depth, temperature, heart rate, blood oxygen, compass heading, ambient pressure, and more - all in real-time.',
      color: '#f44336'
    },
    {
      icon: 'fas fa-cloud',
      title: 'CloudKit Sync',
      description: 'Seamless synchronization across all your Apple devices with automatic backup and conflict resolution.',
      color: '#9C27B0'
    },
    {
      icon: 'fas fa-map-marked-alt',
      title: 'GPS Route Tracking',
      description: 'Record your dive path with GPS breadcrumbs every 30 seconds. View and analyze your underwater journey.',
      color: '#FF9800'
    },
    {
      icon: 'fas fa-mobile-alt',
      title: 'Live Activities',
      description: 'Monitor tissue loading and no-fly time right from your iPhone\'s Dynamic Island and Lock Screen.',
      color: '#2196F3'
    }
  ];

  return (
    <section id="features" className="section-padding bg-alt">
      <Container>
        <div className="text-center mb-5" data-aos="fade-up">
          <h2 className="section-title">Powerful Features</h2>
          <p className="section-subtitle">
            Everything you need for safe and informed diving
          </p>
        </div>
        <Row>
          {features.map((feature, index) => (
            <Col lg={4} md={6} className="mb-4" key={index} data-aos="fade-up" data-aos-delay={index * 100}>
              <div className="feature-card">
                <div className="feature-icon" style={{ background: `linear-gradient(135deg, ${feature.color}dd, ${feature.color}88)` }}>
                  <i className={feature.icon}></i>
                </div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}

export default Features;